<div class="pageContent">
  <div class="pageTitle">
    <h2>Tareas</h2>
  </div>
  <div class="ms-ProgressIndicator" id="progressContainer" style="display: none;">
    <div class="ms-ProgressIndicator-itemName">Actualizando datos...</div>
    <div class="ms-ProgressIndicator-itemProgress">
      <div class="ms-ProgressIndicator-progressTrack"></div>
      <div class="ms-ProgressIndicator-progressBar" id="progressBar"></div>
    </div>
    <div class="ms-ProgressIndicator-itemDescription">Al finalizar, la tabla se recargará</div>
  </div>
  <div class="buscar-variables-container">
    <label class="buscar-variables-label">
      <input type="checkbox" [(ngModel)]="buscarPorVariables" (change)="onBuscarPorVariablesChange()" />
      Buscar por variables
    </label>
  </div>
  <app-data-table *ngIf="tableVisible" tableId="datatableTareas" [serverSide]="true" [serverData]="getDataTableTareas" [columns]="columnas" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtons"></app-data-table>
  <div class="docs-DialogExample-lgHeader">
    <div class="ms-Dialog ms-Dialog--lgHeader cancel-observation" appPreventOutsideClick>
      <div id="dialogCreateEdit" class="ms-Dialog-title">Cancelar ejecución proceso</div>
      <form [formGroup]="cancelProcessForm" (ngSubmit)="enviarAccionProceso()" name="cancelProcessForm">
        <div class="ms-Dialog-content">
          <app-text-area [frm]="cancelProcessForm" formControlName="Observacion" [readonly]="viewObs" [required]="true" label="Observaciones" rows="3"></app-text-area>
        </div>
        <div *ngIf="viewObs" style="margin-top: 24px;">
          <app-button buttonClass="ms-Button ms-Dialog-action" buttonId="btnClose" (buttonClick)="closeCancelModal()" label="Aceptar"></app-button>
        </div>
        <div *ngIf="!viewObs">
          <app-form-buttons 
          [botonProcesando]="botonProcesando"
          buttonCancelId="btnCancel"
          labelCancel="Cancelar"
          buttonSaveId="btnCreateEdit"
          labelSave="Guardar"
          labelLoading="Cargando" 
          [frm]="cancelProcessForm"
          (cancel)="clearCancelForm()">
          </app-form-buttons>
        </div>
      </form>
    </div>
  </div>
</div>

<app-modal-notify #crearModal></app-modal-notify>
